import { render } from "./SwiperWrapper.vue?vue&type=template&id=5df6aff6"
import script from "./SwiperWrapper.vue?vue&type=script&lang=js"
export * from "./SwiperWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__